const WORDS = ["strength", "balance", "self"];

export const Marquee = () => {
  const row = Array(6).fill(WORDS).flat();
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[rgba(26,24,23,0.07)] bg-cream/50 py-7"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {row.map((word, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="font-serif text-3xl italic text-ink/60 sm:text-4xl">{word}</span>
                <span className="mx-8 text-lg text-gold">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
